module.exports = __webpack_public_path__ + "img/error.76b445ee.gif";